import "./../_polyfill/Array_from";
import "./../_polyfill/Array_find";
import "./../_polyfill/Promise";
import flatpickr from "flatpickr";
import { Danish } from "flatpickr/dist/l10n/da.js";
import { Chinese } from "flatpickr/dist/l10n/zh.js";

import { getParameterByName } from "./helperFunctions";

export default class TaxonomyDropdown {
    // Inititialize TaxonomyList for a selection of lists
    static init(querySelector = ".module-taxonomy-dropdown-body") {
        Array.prototype.forEach.call(
            document.querySelectorAll(querySelector),
            taxonomyDropdown => {
                new TaxonomyDropdown(taxonomyDropdown);
            }
        );
    }

    constructor(element) {
        this.element = element;
        this.tags = this.element.getAttribute("data-tags");
        this.selects = Array.from(
            this.element.querySelectorAll(".select-module select")
        );
        this.yearSelect = this.element.querySelector(".years-filter select");
        this.fromDate = this.element.querySelector(".fromdate");
        this.fromPicker;
        this.toDate = this.element.querySelector(".todate");
        this.toPicker;
        this.dataSourceId = element.getAttribute("data-source-id");
        this.currentPageId = this.element.getAttribute("data-current-page-id");
        this.preSelectedTagId = this.element.getAttribute(
            "data-pre-selected-tag-id"
        );
        this.taxonomyListIds = Array.from(
            document.querySelectorAll([".item-list[data-source-id]"])
        ).map(x => x.getAttribute("data-source-id"));

        // Initial fetch
        var pattern = /(\d{2})\-(\d{2})\-(\d{4})/;
        var filterTags = getParameterByName("filter")
            ? getParameterByName("filter").split(" ")
            : [];
        var tagIds = [this.preSelectedTagId]
            .concat(filterTags)
            .filter(x => !!x);
        var year = getParameterByName("year") || undefined;
        var fromDate = getParameterByName("fromDate")
            ? new Date(
                  getParameterByName("fromDate").replace(pattern, "$3-$2-$1")
              )
            : undefined;
        var toDate = getParameterByName("toDate")
            ? new Date(
                  getParameterByName("toDate").replace(pattern, "$3-$2-$1")
              )
            : undefined;
        this.requestFilterOptions(
            this.dataSourceId,
            this.taxonomyListIds,
            this.selects.map(x => x.name),
            tagIds,
            this.tags,
            year,
            fromDate,
            toDate
        ).then(result => {
            // Hide the entire dropdown module if there are no valid options to pick from
            if (
                result.collections.reduce(
                    (t, tagCollection) => t + tagCollection.tags.length,
                    0
                ) === 0 &&
                (result.years === undefined || result.years.length <= 1)
            ) {
                $(this.element)
                    .closest(".module")
                    .addClass("dropdown--no-results");
            } else {
                // Else populate the filters, and select the filter-values from the url, if any
                this.renderFilterOptions(result.collections);
                this.renderYearOptions(result.years);
                this.renderValuesFromParamter();
                this.renderDatepickers(fromDate, toDate);
            }
        });

        this.selects.forEach(select => {
            jQuery(select).on("change", event => {
                // Refetch on change
                let selectedOptions = Array.from(
                    this.element.querySelectorAll(
                        ".select-module option:checked"
                    )
                ).map(x => x.value);
                var tagIds = [this.preSelectedTagId]
                    .concat(selectedOptions)
                    .filter(x => !!x);
                var year = this.yearSelect ? this.yearSelect.value : undefined;
                var fromDate = this.fromDate
                    ? new Date(this.fromDate.value.replace(pattern, "$3-$2-$1"))
                    : undefined;
                var toDate = this.toDate
                    ? new Date(this.toDate.value.replace(pattern, "$3-$2-$1"))
                    : undefined;
                this.requestFilterOptions(
                    this.dataSourceId,
                    this.taxonomyListIds,
                    this.selects
                        .filter(x => x.name !== event.target.name)
                        .map(x => x.name),
                    tagIds,
                    this.tags,
                    year,
                    fromDate,
                    toDate
                ).then(result => {
                    this.renderFilterOptions(result.collections);
                    this.renderYearOptions(result.years);
                    this.renderDatepickers(fromDate, toDate);
                });
            });
        });
        if (this.yearSelect) {
            jQuery(this.yearSelect).on("change", event => {
                // Refetch on change
                let selectedOptions = Array.from(
                    this.element.querySelectorAll(
                        ".select-module option:checked"
                    )
                ).map(x => x.value);
                var tagIds = [this.preSelectedTagId]
                    .concat(selectedOptions)
                    .filter(x => !!x);
                var fromDate = this.fromDate
                    ? new Date(this.fromDate.value.replace(pattern, "$3-$2-$1"))
                    : undefined;
                var toDate = this.toDate
                    ? new Date(this.toDate.value.replace(pattern, "$3-$2-$1"))
                    : undefined;
                this.requestFilterOptions(
                    this.dataSourceId,
                    this.taxonomyListIds,
                    this.selects
                        .filter(x => x.name !== event.target.name)
                        .map(x => x.name),
                    tagIds,
                    this.tags,
                    this.yearSelect.value,
                    fromDate,
                    toDate
                ).then(result => {
                    this.renderFilterOptions(result.collections);
                    this.renderYearOptions(result.years);
                    this.renderDatepickers(fromDate, toDate);
                });
            });
        }
        if (this.fromDate) {
            var lang = $("html").attr("lang");
            const langMap = {
                da: Danish,
                zh: Chinese,
                en: ""
            };
            if (lang !== "en") {
                flatpickr.localize(langMap[lang]);
            } else {
                flatpickr.l10ns.default.firstDayOfWeek = 1;
            }
            var _self = this;
            this.fromPicker = flatpickr(this.fromDate, {
                dateFormat: "d-m-Y",
                altInput: true,
                altFormat: "F j, Y",
                // onChange: function (selectedDates, dateStr, instance) {
                //     // _self.toPicker.set('minDate', dateStr)
                //     _self.datepickersChanged()
                // },
                onDayCreate: function(dObj, dStr, fp, dayElem) {
                    if (
                        _self.toPicker &&
                        +_self.toPicker.selectedDates[0] === +dayElem.dateObj
                    ) {
                        dayElem.className += " flatpickr-highlight";
                    }
                }
            });
            this.toPicker = flatpickr(this.toDate, {
                dateFormat: "d-m-Y",
                altInput: true,
                altFormat: "F j, Y",
                // onChange: function (selectedDates, dateStr, instance) {
                //     // _self.fromPicker.set('maxDate', dateStr)
                //     _self.datepickersChanged()
                // },
                onDayCreate: function(dObj, dStr, fp, dayElem) {
                    if (
                        _self.fromPicker &&
                        +_self.fromPicker.selectedDates[0] === +dayElem.dateObj
                    ) {
                        dayElem.className += " flatpickr-highlight";
                    }
                }
            });
            if (fromDate) {
                this.fromPicker.setDate(fromDate);
                this.toPicker.set("minDate", fromDate);
            }
            if (toDate) {
                this.toPicker.setDate(toDate);
                this.fromPicker.set("maxDate", toDate);
            }
        }

        this.element.querySelector("form").addEventListener("submit", event => {
            event.preventDefault();
            this.updateFilterParameter();
        });
    }

    renderFilterOptions(collections) {
        // Else we populate each dropdown
        collections.forEach(tagCollection => {
            var select = this.selects.find(x => x.name === tagCollection.id);
            let selectedOptions = Array.from(
                this.element.querySelectorAll(".select-module option:checked")
            );

            // Render new select-values and make sure previous value is still selected
            while (select.options.length) {
                select.options.remove(0);
            }
            let o = new Option(`${tagCollection.title}`, "");
            select.options.add(o);
            o.setAttribute("data-title", tagCollection.title);
            tagCollection.tags.forEach(tag => {
                let t = new Option(`${tag.title} (${tag.facetCount})`, tag.id);
                select.options.add(t);
                t.setAttribute("data-title", tag.title);
            });

            // Move items into an array
            var elements = Array.prototype.slice.call(select.options);

            // Sort the array alphabetically
            elements.sort(function(a, b) {
                return a.textContent.localeCompare(b.textContent);
            });

            // Reattach sorted items
            for (var i = 0, len = elements.length; i < len; i++) {
                var parent = elements[i].parentNode;
                var detatchedItem = parent.removeChild(elements[i]);
                parent.appendChild(detatchedItem);
            }
            let newOptions = Array.from(
                this.element.querySelectorAll(".select-module option")
            );
            selectedOptions.forEach(selectedOption => {
                let newOp = newOptions.find(
                    newOption =>
                        newOption.dataset.title === selectedOption.dataset.title
                );
                if (newOp) {
                    newOp.selected = true;
                }
            });
            jQuery(select).niceSelect("update");

            // Let's hide the select if there are no options
            if (select.options.length <= 1) {
                select.parentElement.style.display = "none";
            } else {
                select.parentElement.style.display = "";
            }
        });
    }

    renderYearOptions(years) {
        if (this.yearSelect) {
            var selectedValue = this.yearSelect.value;
            // Render new select-values and make sure previous value is still selected
            while (this.yearSelect.options.length) {
                this.yearSelect.options.remove(0);
            }

            var isDefaultOption = true;
            years.forEach(year => {
                if (isDefaultOption) {
                    let o = new Option(`${year.title}` || "", year.id);
                    this.yearSelect.options.add(o);
                    o.setAttribute("data-title", year.title);
                    isDefaultOption = false;
                } else {
                    let y = new Option(
                        `${year.title} (${year.facetCount})` || "",
                        year.id
                    );
                    this.yearSelect.options.add(y);
                    y.setAttribute("data-title", year.title);
                }
            });

            this.yearSelect.value = selectedValue;
            if (!this.yearSelect.value && this.yearSelect.options.length > 0) {
                this.yearSelect.options[0].selected = "selected";
            }
            jQuery(this.yearSelect).niceSelect("update");

            if (this.yearSelect.options.length <= 2) {
                this.yearSelect.parentElement.style.display = "none";
            } else {
                this.yearSelect.parentElement.style.display = "";
            }
        }
    }

    requestFilterOptions(
        DropDownDataSourceId,
        DataSourcesIds,
        TagCollectionsIds,
        TagsIds,
        Tags,
        Year,
        FromDate,
        ToDate
    ) {
        return new Promise((resolve, reject) => {
            jQuery.ajax({
                type: "POST",
                url: `/api/taxonomylist/GetDroprdownTagCollections?sc_itemid=${this.currentPageId}`,
                data: JSON.stringify({
                    DropDownDataSourceId,
                    DataSourcesIds,
                    TagCollectionsIds,
                    TagsIds,
                    Tags,
                    Year,
                    FromDate,
                    ToDate
                }),
                success: resolve,
                failure: reject,
                dataType: "json",
                contentType: "application/json"
            });
        });
    }

    renderDatepickers(from, to) {
        if (this.fromDate) {
            if (from !== "null") {
                this.toPicker.set("minDate", from);
            }
            if (to !== "null") {
                this.fromPicker.set("maxDate", to);
            }
        }
    }

    renderValuesFromParamter() {
        if (getParameterByName("filter")) {
            var taxonomyDropdownFilters = getParameterByName("filter")
                .split(" ")
                .filter(x => x !== "");
            taxonomyDropdownFilters.forEach(filter => {
                this.selects.forEach(select => {
                    var optionWithFilter = Array.from(select.options).find(
                        option => option.value === filter
                    );
                    if (optionWithFilter) {
                        select.value = optionWithFilter.value;
                        jQuery(select).niceSelect("update");
                    }
                });
            });
        }
        if (this.yearSelect && getParameterByName("year")) {
            this.yearSelect.value = getParameterByName("year");
            jQuery(this.yearSelect).niceSelect("update");
        }
    }

    updateFilterParameter() {
        var taxonomyDropdownFilters = Array.from(
            this.element.querySelectorAll(".select-module option:checked")
        )
            .map(filterElement => {
                return filterElement.value;
            })
            .filter(x => x !== "");

        var params = [];
        if (taxonomyDropdownFilters.length > 0) {
            params.push(`filter=${taxonomyDropdownFilters.join("+")}`);
        }
        if (this.yearSelect && this.yearSelect.value !== "") {
            params.push(`year=${this.yearSelect.value}`);
        }
        if (this.fromDate && this.fromDate.value !== "") {
            params.push(`fromDate=${this.fromDate.value}`);
        }
        if (this.toDate && this.toDate.value !== "") {
            params.push(`toDate=${this.toDate.value}`);
        }
        if (this.fromDate && this.toDate) {
            this.renderDatepickers(this.fromDate.value, this.toDate.value);
        }
        if (location.hash !== params.join("&")) {
            location.hash = params.join("&");
        }
    }

    /* Not used currently */
    datepickersChanged() {
        let selectedOptions = Array.from(
            this.element.querySelectorAll(".select-module option:checked")
        ).map(x => x.value);
        var tagIds = [this.preSelectedTagId]
            .concat(selectedOptions)
            .filter(x => !!x);
        var year = this.yearSelect ? this.yearSelect.value : undefined;
        var fromDate = this.fromDate
            ? JSON.stringify(
                  new Date(this.fromDate.value.replace(pattern, "$3-$2-$1"))
              )
            : undefined;
        var toDate = this.toDate
            ? JSON.stringify(
                  new Date(this.toDate.value.replace(pattern, "$3-$2-$1"))
              )
            : undefined;
        this.requestFilterOptions(
            this.dataSourceId,
            this.taxonomyListIds,
            this.selects
                .filter(x => x.name !== event.target.name)
                .map(x => x.name),
            tagIds,
            this.tags,
            year,
            fromDate,
            toDate
        ).then(result => {
            this.renderFilterOptions(result.collections);
            this.renderYearOptions(result.years);

            this.renderDatepickers(fromDate, toDate);
        });
    }
}
